var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-bubble"},[_c('div',{ref:"content",staticClass:"content",class:[
            _vm.background ? (_vm.background + "-background") : '',
            _vm.speechTail ? (_vm.speechTail + "-speech-tail") : '' ]},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }